import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import * as fromModifiedFirstParties from './reducers';
import { EffectsModule } from "@ngrx/effects";
import { ModifiedFirstPartiesEffects } from "./effects/modified-first-parties.effects";

@NgModule({
  imports: [
    StoreModule.forFeature(
      fromModifiedFirstParties.modifiedFirstPartiesKey,
      fromModifiedFirstParties.reducers
    ),
    EffectsModule.forFeature([
      ModifiedFirstPartiesEffects
    ])
  ]
})
export class ModifiedFirstPartiesModule { }